import Navbar from "../../Navbar";
import { UrlApi } from "../../../services/apirest";
import { useEffect, useState } from "react";
import { logEventos } from "../../../services/services";
import {
  Typography,
  Box,
  Button,
  TextField,
  Paper,
  Grid,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
import Tablaresumen from "./Tablaresumen";
import { getData } from "../../../services/library";

// COMPONENTE AUTOCOMPLETE
const ComboBoxUsuarios = ({
  usuarios,
  datosempleado,
  almacenar,
  rrhhAdmin,
}) => {
  const usuarioActual = usuarios.find(
    (u) => u.username === datosempleado.usuario
  );

  return (
    <Autocomplete
      fullWidth
      size="small"
      disabled={rrhhAdmin !== "1"}
      options={[...usuarios].sort((a, b) =>
        a.username.localeCompare(b.username)
      )}
      getOptionLabel={(option) => option.username}
      value={usuarioActual || null}
      onChange={(event, newValue) => {
        if (newValue) {
          almacenar({
            target: { name: "usuario", value: newValue.username },
          });
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label="Usuario" variant="outlined" />
      )}
      isOptionEqualToValue={(option, value) =>
        option.username === value.username
      }
    />
  );
};

// COMPONENTE PRINCIPAL
function Resumenxempleado() {
  const [mostrarResumen, setMostrarResumen] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const rrhhAdmin = localStorage.getItem("adminrrhh");
  const user = localStorage.getItem("user");

  const [datosempleado, setDatosempleado] = useState({
    usuario: user ?? "",
    fechainicio: "",
    fechafin: "",
  });

  const [datos, setDatos] = useState();

  useEffect(() => {
    getData(`/viandas/menu/users`, setUsuarios);
  }, []);

  useEffect(() => {
    const hoy = moment();
    const diaDeLaSemana = hoy.isoWeekday();
    const proximoLunes = moment()
      .add(8 - diaDeLaSemana, "days")
      .startOf("day");
    const proximoViernes = moment(proximoLunes).add(4, "days");

    setDatosempleado((prev) => ({
      ...prev,
      fechainicio: proximoLunes.format("YYYY-MM-DD"),
      fechafin: proximoViernes.format("YYYY-MM-DD"),
    }));
  }, []);

  function almacenar(e) {
    setDatosempleado({
      ...datosempleado,
      [e.target.name]: e.target.value,
    });
  }

  const handleConsultar = async () => {
    const { usuario, fechainicio, fechafin } = datosempleado;

    try {
      const response = await fetch(
        `${UrlApi}/viandas/pedidos?username=${usuario}&fechaInicio=${fechainicio}&fechaFin=${fechafin}`
      );
      if (!response.ok) throw new Error("Error al obtener los pedidos");
      const data = await response.json();
      setDatos(data.data);
      setMostrarResumen(true);
    } catch (error) {
      console.error("Error en la consulta:", error);
    }
  };


  useEffect(() => {
  logEventos(
    "acceso al menú Viandas por empleado", 
  "Viandas",
   "resuemn Viandas por empleado", 
   localStorage.getItem("user"));
}, []);
  return (
    <>
      <Navbar />
      {!mostrarResumen && (
        <Box
          sx={{
            maxWidth: 400,
            margin: "auto",
            mt: 5,
            p: 3,
            bgcolor: "#e3f2fd",
            borderRadius: 2,
            boxShadow: 3,
          }}
          component={Paper}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Resumen Viandas Por Empleado
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ComboBoxUsuarios
                usuarios={usuarios}
                datosempleado={datosempleado}
                almacenar={almacenar}
                rrhhAdmin={rrhhAdmin}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                type="date"
                size="small"
                name="fechainicio"
                label="Fecha Inicio"
                onChange={almacenar}
                value={moment(datosempleado.fechainicio).format("YYYY-MM-DD")}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                type="date"
                size="small"
                name="fechafin"
                label="Fecha Fin"
                inputProps={{ min: datosempleado.fechainicio }}
                onChange={almacenar}
                value={moment(datosempleado.fechafin).format("YYYY-MM-DD")}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleConsultar}
                disabled={
                  !datosempleado.usuario ||
                  !datosempleado.fechainicio ||
                  !datosempleado.fechafin
                }
              >
                Consultar
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}

      {mostrarResumen && (
        <Tablaresumen
          data={datos}
          setMostrarResumen={setMostrarResumen}
          datosempleado={datosempleado}
        />
      )}
    </>
  );
}

export default Resumenxempleado;
